import { cloneDeep, startCase } from "lodash";
import { Account } from "./";

const DEFAULT_ATTRIBUTES = {
  name: null,
  archived: false,
  address: {
    street_name: null,
    street_number: null,
    zip_code: null,
    unit: null,
    floor: null,
    address_line: null,
    line: null,
    city: null,
    accuracy: null,
    lon: null,
    lat: null,
    phone: null,
    country: {
      name: "Argentina",
      code: "AR",
    },
    state: "Ciudad Autónoma de Buenos Aires",
  },
  owner_account: null,
  seller_id: null,
  operation_from_hour: "08:00",
  operation_to_hour: "18:00",
  virtual: false,
};
export class Warehouse {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];

      if (this.owner_account) {
        this.owner_account = new Account(this.owner_account);
      }
    });
  }

  get cookedState() {
    return `${this.address.city}, ${this.address.state}`;
  }

  get cookedCompanyName() {
    return this.owner_account ? this.owner_account.cookedCompanyName : "";
  }

  get companyName() {
    return this.owner_account.company_name;
  }

  get cookedOperationTimeframe() {
    return `${this.operation_from_hour} a ${this.operation_to_hour} hs`;
  }

  get addressRegion() {
    if (this.address.state === this.address.city) {
      return `${startCase(this.address.city.toLowerCase())}`;
    }

    return `${startCase(this.address.city.toLowerCase())}, ${startCase(
      this.address.state.toLowerCase()
    )}`;
  }

  get googleMapsCoordinates() {
    if (!this.address) return "";

    return `${this.address.lat}, ${this.address.lon}`;
  }

  get cookedStreet() {
    return `${this.address.street_name} ${this.address.street_number}`;
  }

  get cookedFloor() {
    return `${this.address.floor || ""} ${" "}${this.address.unit || ""}`;
  }

  get cookedAddress() {
    if (this.cookedFloor) return `${this.cookedStreet}, ${this.cookedFloor}`;

    return `${this.cookedStreet}`;
  }

  get addressSummary() {
    if (
      !this.address ||
      !this.address.address_line ||
      !this.address.street_name ||
      !this.address.street_number ||
      !this.address.city
    ) {
      return "";
    }
    if (this.address.address_line) {
      return `${this.address.address_line}, ${this.address.city}`;
    } else {
      return `${this.address.street_name || ""} ${
        this.address.street_number ? `${this.address.street_number},` : ""
      } ${this.address.unit ? `${this.address.unit},` : ""} ${
        this.address.city
      }`;
    }
  }

  setAddressLonLat(lon, lat) {
    this.address.lonlat = `POINT(${lon} ${lat})`;
  }
}
